<template>
  <div class="lv_flexalign_center act_layout">
    <div @click="remove" class="act_button">删除选中花材</div>
    <div @click="clear" class="act_button">全部删除</div>
  </div>
</template>

<script>
import { Dialog } from "vant";

export default {
  props: ["selectedMaterial"],
  methods: {
    remove() {
      if (this.selectedMaterial) {
        this.$bus.$emit("remove", this.selectedMaterial.id);
      }
    },
    clear() {
      Dialog.confirm({
        title: "提示",
        message: "是否全部删除当前画布中的花材和容器？",
        confirmButtonText: "确认",
        cancelButtonText: "取消",
      })
        .then(() => {
          this.$bus.$emit("clear");
        })
        .catch(() => {});
    },
  },
};
</script>
